export default __webpack_public_path__ + "static/media/ImgGAN_InterpBilinear_shrunk.e34fb3d6.png";